import User from '../Types/User';

const defaultUser: User = {
	name: 'واله',
	mobile: '09192345678',
	credit: -800,
};

export default defaultUser;
